







































import { Component, Vue, Ref } from 'vue-property-decorator';
import Order from '@/components/Invoicing/Order/Order.vue';
import OrderEditControls from '@/components/Invoicing/Order/Controls/OrderEditControls.vue';
import { GET_ORDER, UPDATE_ORDER } from '@/queries/Order';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import { formDataToMutationInput, modifyOrderData } from '@/app/Order';
import { GQL_order_order } from '@/queries/__generated__/order';
import sameUnitOrdersGuard from '@/guards/same-unit-orders-guard';
import checkSupplierMandatoryFieldsGuard from '@/guards/order-supplier-party-guard';

@Component({
  components: {
    Order,
    OrderEditControls,
  },
  beforeRouteEnter: (to, from, next) => {
    sameUnitOrdersGuard(to, from, next).then(success => {
      if (!success) return;
      checkSupplierMandatoryFieldsGuard().catch(router => {
        router.push({ name: 'Orders' });
        router.app.$sMessage.error(router.app.$t('Order.supplierPartyIsMissingInfo'), { duration: 0 });
      });
    });
  },
  beforeRouteUpdate: (to, from, next) => {
    sameUnitOrdersGuard(to, from, next).then(success => {
      if (!success) return;
      checkSupplierMandatoryFieldsGuard().catch(router => {
        router.push({ name: 'Orders' });
        router.app.$sMessage.error(router.app.$t('Order.supplierPartyIsMissingInfo'), { duration: 0 });
      });
    });
  },
})
export default class OrdersEdit extends Vue {
  private GET_ORDER = GET_ORDER;
  @UnsavedChanges<OrdersEdit>({
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) public dirtyForm = false;
  public validForm = true;
  private formatData = formDataToMutationInput;
  private modifyOrderData = modifyOrderData;
  private data: {order: GQL_order_order} | null = null;

  @Ref() public readonly orderRef!: Order;

  private saveAndContinue() {
    if (!this.data) return false;
    return this.$apollo.mutate({
      mutation: UPDATE_ORDER,
      variables: this.formatData(this.data),
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private resetFormDirty() {
    this.orderRef.formRef?.resetDirty();
  }
}
